import {
  ColorScheme,
  colorSchemeFor,
  LIGHT_MEDIA_QUERY,
} from "@helpers/colorScheme"
import { useSyncExternalStore } from "react"

function subscribe(onChange: () => void) {
  const query = window.matchMedia?.(LIGHT_MEDIA_QUERY)

  query?.addEventListener("change", onChange)

  return () => query?.removeEventListener("change", onChange)
}

/** The page's color scheme (see helpers/colorScheme.ts), kept up to date. */
export default function useColorScheme(): ColorScheme {
  return useSyncExternalStore(subscribe, () => colorSchemeFor())
}
